export enum NotificationDeliveryMethod {
    Email = 'email',
    Slack = 'slack',
}
